import { useQuery } from '@tanstack/react-query';
import { User } from '../types/user';

// Mock data
const mockUsers: Record<string, User> = {
  "1": {
    id: "1",
    firstName: "John",
    lastName: "Smith",
    email: "john.smith@medipadi.com",
    role: "Physician",
    title: "Dr.",
    specialization: "General Practitioner",
    permissions: {
      patients: "edit",
      visits: "edit",
      inventory: "view",
      outreach: "view",
      admin: false
    }
  },
  "2": {
    id: "2",
    firstName: "Sarah",
    lastName: "Johnson",
    email: "sarah.johnson@medipadi.com",
    role: "Physician",
    title: "Dr.",
    specialization: "Pediatrician",
    permissions: {
      patients: "edit",
      visits: "edit",
      inventory: "view",
      outreach: "edit",
      admin: false
    }
  }
};

async function fetchUser(id: string): Promise<User> {
  // Simulate network delay
  await new Promise(resolve => setTimeout(resolve, 100));
  
  const user = mockUsers[id];
  if (!user) {
    throw new Error('User not found');
  }
  
  return user;
}

export function useUser(id?: string) {
  return useQuery({
    queryKey: ['user', id],
    queryFn: () => fetchUser(id!),
    enabled: !!id,
  });
}
